import dashboard from './dashboard';
import exporting from './export';

// ==============================|| MENU ITEMS ||============================== //

const menuItemsManager = {
    items: [dashboard, exporting]
};

export default menuItemsManager;
